import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import TinyPopover from '../TinyPopover';

var PopoverOnHover =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PopoverOnHover, _React$Component);

  function PopoverOnHover() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PopoverOnHover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PopoverOnHover)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "open", function () {
      _this.timeout = setTimeout(function () {
        _this.setState({
          isOpen: true
        });
      }, _this.props.delayShow);
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      clearTimeout(_this.timeout);

      if (_this.state.isOpen) {
        _this.setState({
          isOpen: false
        });
      }
    });

    return _this;
  }

  _createClass(PopoverOnHover, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var content = _ref.content;

      if (content !== this.props.content) {
        this.close();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(TinyPopover, {
        isOpen: this.state.isOpen,
        transitionDuration: this.props.transitionDuration,
        position: this.props.position,
        content: this.props.content // overrides default `overflow: hidden`, allowing box-shadows to be visible
        ,
        containerStyle: _objectSpread({
          overflow: 'visible',
          zIndex: 13
        }, this.props.containerStyle),
        className: this.props.className
      }, React.cloneElement(React.Children.only(this.props.children), {
        onMouseOver: function onMouseOver() {
          var _this2$props$children = _this2.props.children.props;
          _this2$props$children = _this2$props$children === void 0 ? {} : _this2$props$children;
          var onMouseOver = _this2$props$children.onMouseOver;
          onMouseOver && onMouseOver();

          _this2.open();
        },
        onMouseOut: function onMouseOut() {
          var _this2$props$children2 = _this2.props.children.props;
          _this2$props$children2 = _this2$props$children2 === void 0 ? {} : _this2$props$children2;
          var onMouseOut = _this2$props$children2.onMouseOut;
          onMouseOut && onMouseOut();

          _this2.close();
        },
        onClick: function onClick() {
          var _this2$props$children3 = _this2.props.children.props;
          _this2$props$children3 = _this2$props$children3 === void 0 ? {} : _this2$props$children3;
          var onClick = _this2$props$children3.onClick;
          onClick && onClick.apply(void 0, arguments);

          _this2.close();
        }
      }));
    }
  }]);

  return PopoverOnHover;
}(React.Component);

_defineProperty(PopoverOnHover, "propTypes", {
  children: PropTypes.node.isRequired,
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  position: PropTypes.string.isRequired,
  delayShow: PropTypes.number.isRequired,
  transitionDuration: PropTypes.number,
  containerStyle: PropTypes.object,
  className: PropTypes.string
});

_defineProperty(PopoverOnHover, "defaultProps", {
  delayShow: 0,
  transitionDuration: 0.25,
  containerStyle: {}
});

export { PopoverOnHover as default };